module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/6_fea569105bb8f9b7cfbab4a0efbb19c4.png";